module.exports = __webpack_public_path__ + "img/login-bg.720a538a.jpg";